/**
 * Screensaver mode — behavior config + camera/transition tunables.
 *
 * SCREENSAVER_CONFIG is a ModeUrlConfig consumed by coerceModeUrl in
 * applyModeUrlCoercion.ts (the /screensaver route). Peaceful mode is applied
 * via the &peaceful=1 URL param (sticky `helix_peaceful`, server-granted on any
 * map) — NOT a field here. The cycle list lives in screensaverCycle.ts.
 */

import type { ModeUrlConfig } from '../boot/coerceModeUrl';

export const SCREENSAVER_CONFIG: ModeUrlConfig = {
  resetOnLoad: true,
  preset: 'live-lobby', // clean viewport — no debug panels on stream
  skipSplash: true,
  skipLogin: true,
  autoClass: 'mage', // class is irrelevant for a screensaver; skip the picker
};

export const SCREENSAVER_TUNABLES = {
  /** Default seconds per biome when a stop omits its own durationS. */
  defaultStopDurationS: 40,
  /** Per-waypoint camera pan time (cubic-out). */
  panDurationS: 16,
  /** Camera waypoints computed per biome. */
  waypointsPerStop: 4,
  /** Keep waypoints this fraction off the map edges. */
  edgeMarginPct: 0.1,
  /** Wide-ish framing for the tour. */
  zoom: 0.8,
  /** Alt zoom toggled by the Z key (close framing). */
  zoomClose: 1.1,
  /** Overlay fade-to-black duration on biome transition (ms). */
  fadeMs: 1500,
  /** Biome-name overlay timing (seconds). */
  overlay: { fadeInS: 2, holdS: 5, fadeOutS: 2 },
} as const;
